export default __webpack_public_path__ + "static/media/icon_mail.21b78ee8.svg";